// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from './assets/js/http'
Vue.prototype.http=http;
import apiType from './assets/js/apiType'
Vue.prototype.apitype=apiType;
import rules from './assets/js/rules'
import 'default-passive-events'
import Breadcrumb from '@/components/Breadcrumb'
Vue.component('Breadcrumb',Breadcrumb);//全局引入面包屑
import URL from '@/assets/js/url'
Vue.prototype.URL=URL;//配置URl
import moment from 'moment'
Vue.prototype.$moment = moment;//日期格式化
Vue.prototype.rules=rules;

import ElementUI from 'element-ui';
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;//文本复制
Vue.config.productionTip = false;

//表格头部图标
import tableIcons from './assets/js/tableIcons.js'
Vue.prototype.tableIcons=tableIcons;

//过滤器
import vueFilter from './assets/js/filters'
for (let key in vueFilter){
    Vue.filter(key,vueFilter[key])
}

//设置标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title + ' - KnowSafe'
    }
    next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js